import React from 'react'
import { format } from 'date-fns'
import type { IUserPositionDay } from '@/api/user/getUserMonthAvailability.ts'
import { CalendarCellState, calendarCellState } from '@/util/positionAvailability.ts'

export interface IProps {
    dates: Date[]
    currentMonth: Date
    today: Date
    selectedDate: string
    isLoading: boolean
    isBusy?: boolean
    availability: Map<string, IUserPositionDay>
    onSelect: (date: string) => void
}

// 새 달의 기록을 기다리는 동안 직전 달을 그대로 두되, 오래 걸릴 때만(0.3초 뒤) 살짝 흐리게 해서 알린다.
const BUSY_STYLE = 'opacity-60 transition-opacity delay-300 duration-200'

const CELL_BASE = 'w-8 h-8 text-sm rounded-full flex items-center justify-center relative'

const CELL_STYLES: Record<CalendarCellState, string> = {
    outside: 'text-gray-300 cursor-default',
    future: 'text-gray-300 cursor-not-allowed',
    selected: 'bg-blue-500 text-white cursor-pointer',
    loading: 'text-gray-400 cursor-default',
    located: 'text-black hover:bg-blue-100 cursor-pointer',
    'unavailable-only': 'text-amber-600 hover:bg-amber-50 cursor-pointer',
    none: 'text-gray-400 cursor-not-allowed'
}

const AvailabilityCalendarGrid: React.FC<IProps> = ({
    dates,
    currentMonth,
    today,
    selectedDate,
    isLoading,
    isBusy = false,
    availability,
    onSelect
}) => (
    <div className={`grid grid-cols-7 gap-1${isBusy ? ` ${BUSY_STYLE}` : ''}`}>
        {dates.map(date => {
            const dateString = format(date, 'yyyy-MM-dd')
            const { state, selectable } = calendarCellState({
                date,
                currentMonth,
                today,
                selectedDate,
                isLoading,
                day: availability.get(dateString)
            })

            return (
                <div
                    key={dateString}
                    data-state={state}
                    className={`${CELL_BASE} ${CELL_STYLES[state]}`}
                    onClick={() => {
                        if (selectable) onSelect(dateString)
                    }}
                >
                    {date.getDate()}
                    {state === 'loading' && (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-1 h-1 bg-blue-500 rounded-full animate-pulse"></div>
                        </div>
                    )}
                </div>
            )
        })}
    </div>
)

export default AvailabilityCalendarGrid
